export const BankList = [
  'Abhyudaya Co-Operative Bank Ltd',
  'Allahabad Bank',
  'Andhra Bank',
  'Andhra Pradesh Grameena Bank',
  'Arunachal Pradesh Rural Bank',
  'Assam Gramin Vikash Bank',
  'AU Small Finance Bank',
  'Axis Bank',
  'Bandhan Bank',
  'Bank of America',
  'Bank of Bahrain and Kuwait',
  'Bank of Baroda',
  'Bank of India',
  'Bank of Maharashtra',
  'Bihar Gramin Bank',
  'BNP Paribas',
  'Canara Bank',
  'Catholic Syrian Bank',
  'Central Bank of India',
  'Chhattisgarh Rajya Gramin Bank',
  'Citibank',
  'City Union Bank',
  'Corporation Bank',
  'CSB Bank',
  'DBS Bank',
  'DCB Bank',
  'Deutsche Bank',
  'Dhanlaxmi Bank',
  'Equitas Small Finance Bank',
  'Federal Bank',
  'GP Parsik Bank',
  'Gujarat Gramin Bank',
  'HDFC Bank',
  'Himachal Pradesh Gramin Bank',
  'HSBC Bank India',
  'ICICI Bank',
  'IDBI Bank',
  'IDFC First Bank',
  'Indiabulls',
  'Indian Bank',
  'Indian Overseas Bank',
  'IndusInd Bank',
  'ING Vysya Bank',
  'Jammu and Kashmir Bank',
  'Jammu and Kashmir Grameen Bank',
  'Jharkhand Rajya Gramin Bank',
  'JPMorgan Chase',
  'Karnataka Bank',
  'Karnataka Grameena Bank',
  'Karur Vysya Bank',
  'Kerala Gramin Bank',
  'Kotak Mahindra Bank',
  'Lakshmi Vilas Bank',
  'Madhya Pradesh Gramin Bank',
  'Maharashtra Gramin Bank',
  'Manipur Rural Bank',
  'Meghalaya Rural Bank',
  'Mizoram Rural Bank',
  'Nagaland Rural Bank',
  'Nainital Bank',
  'Odisha Gramin Bank',
  'Oriental Bank of Commerce',
  'Paytm Payments Bank',
  'Puduvai Bharathiar Grama Bank',
  'Punjab and Sind Bank',
  'Punjab Gramin Bank',
  'Punjab National Bank',
  'Rajasthan Gramin Bank',
  'RBL Bank',
  'Sarva Haryana Gramin Bank',
  'Shamrao Vitthal Co-operative Bank',
  'South Indian Bank',
  'Standard Chartered',
  'State Bank of Bikaner & Jaipur',
  'State Bank of Hyderabad',
  'State Bank of India',
  'State Bank of Mysore',
  'State Bank of Patiala',
  'State Bank of Travancore',
  'Syndicate Bank',
  'Tamil Nadu Grama Bank',
  'Tamilnad Mercantile Bank',
  'Telangana Grameena Bank',
  'Tripura Gramin Bank',
  'UCO Bank',
  'Ujjivan Small Finance Bank',
  'Union Bank of India',
  'United Bank of India',
  'Uttar Pradesh Gramin Bank',
  'Uttarakhand Gramin Bank',
  'Vijaya Bank',
  'West Bengal Gramin Bank',
  'Yes Bank',
  'Other'
];
